import { render, staticRenderFns } from "./EditModel.vue?vue&type=template&id=b0a6daaa&scoped=true"
import script from "./EditModel.vue?vue&type=script&lang=js"
export * from "./EditModel.vue?vue&type=script&lang=js"
import style0 from "./EditModel.vue?vue&type=style&index=0&id=b0a6daaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a6daaa",
  null
  
)

export default component.exports